import React, { useState } from "react";
import { BACKGROUND_COLOR_HEX_KEY, DEFAULT_BACKGROUND_COLOR_HEX, DEFAULT_EMOJI, DEFAULT_SHOW_BUBBLES, Emoji, EMOJI_KEY, SHOW_BUBBLES_KEY } from "../constants/theme";
import ThemeContext from "../contexts/ThemeContext";
import { tryToGetBooleanFromLocalStorage } from "../helpers/localstorage";

const ThemeProvider: React.FC = ({ children }) => {
  const [emoji, setEmoji]
    = useState<Emoji>(localStorage.getItem(EMOJI_KEY) as Emoji || DEFAULT_EMOJI);

  const [backgroundColorHex, setBackgroundColorHex]
    = useState<string>(localStorage.getItem(BACKGROUND_COLOR_HEX_KEY) || DEFAULT_BACKGROUND_COLOR_HEX);

  const [showBubbles, setShowBubbles]
    = useState<boolean>(tryToGetBooleanFromLocalStorage(SHOW_BUBBLES_KEY, DEFAULT_SHOW_BUBBLES));

  const updateEmoji = (newEmoji: Emoji) => {
    setEmoji(newEmoji);
    localStorage.setItem(EMOJI_KEY, newEmoji);
  }

  const updateBackgroundColorHex = (newColor: string) => {
    setBackgroundColorHex(newColor);
    localStorage.setItem(BACKGROUND_COLOR_HEX_KEY, newColor);
  }

  const updateShowBubbles = (newValue: boolean) => {
    setShowBubbles(newValue);
    localStorage.setItem(SHOW_BUBBLES_KEY, String(newValue));
  }

  return (
    <ThemeContext.Provider value={{
      emoji, updateEmoji,
      backgroundColorHex, updateBackgroundColorHex,
      showBubbles, updateShowBubbles
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;